import { Observable } from 'rxjs';

import { IAgGridDropdownMenuOption } from 'v2/modules/shared/components/ag-grid-dropdown-menu-cell-renderer/ag-grid-dropdown-menu-cell-renderer.component';

export enum EShipmentsGridField {
  ID = 'id',
  SHIPMENT_ID = 'shipmentId',
  FULFILLMENT_ID = 'fulfillmentId',
  STATUS = 'status',
  SHIP_DATE = 'shipDate',
  TRACKING_NUMBER = 'trackingNumber',
  CARRIER_CODE = 'carrierCode',
  CUSTOMER_NAME = 'customerName',
  SHIPPING_ADDRESS = 'shippingAddress',
  SHIPMENT_COST = 'shipmentCost',
}

export enum EShipmentsDetailGridField {
  SKU = 'sku',
  NAME = 'name',
  QUANTITY = 'quantity',
  UNIT_PRICE = 'unitPrice',
  STATUS = 'status',
}

export interface IShipmentsGridColumnDefContext {
  dropdownOptions: IAgGridDropdownMenuOption[];
}

export enum EShipmentGridDropdownAction {
  CREATE_INVOICE_FROM_SHIPMENT = 'create_invoice_from_shipment',
}

export interface IShipmentsGridOptionsContext {
  saveGridState: () => void;
  refetchGridData: () => void;
  updateSelectedRows: () => void;
  fetchShipmentDetails: (shipstationShipmentId: number) => Observable<any>;
}
